var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBin = function SvgIcBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.692 6.462H5.54m0 0h14.769m-14.77 0v12.923a1.846 1.846 0 0 0 1.847 1.846h9.23a1.846 1.846 0 0 0 1.847-1.846V6.462H5.539Zm2.77 0V4.615a1.846 1.846 0 0 1 1.846-1.846h3.692a1.846 1.846 0 0 1 1.846 1.846v1.847"
  })));
};
export default SvgIcBin;